import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// import styles
import './supportaccessuser.scss'

// action
import {getImpersonationAccess, saveImpersonationAccess} from '../../actions/employees'

// Utils
import { translation } from '../../utils/helpers'

// Elements
import Col from '../../shared/elements/col'
import Panel from '../../shared/elements/panel'
import Switch from '../../shared/elements/switch'
import DateTime from '../../shared/elements/datetime'
import Grid from '../../shared/elements/grid'
import LabelWrapper from '../../shared/elements/labelWrapper'
import DropDown from '../../shared/elements/dropDown'
import Label from '../../shared/elements/label'

class SupportAccessUser extends Component {
  constructor (props) {
    super(props)

    // create hours list
    const timeLabels = []
    for (let i = 0; i < 24; i++) {
      let hh = i.toString()
      let hour = '00'.substring(0, 2 - hh.length) + hh
      timeLabels.push(hour + ':' + '00')
      timeLabels.push(hour + ':' + '30')
    }

    this.state = {
      ImpersonateAccessInfo: {
        ImpersonationAccessEnabled: false,
        ImpersonationExpiryDate: moment().format('DD-MM-YYYY HH:mm:ss'),
        SupportTeams: []
      },
      SupportAccessTimes: timeLabels,
      previewDateTime: null
    }
    this.onChange = this.onChange.bind(this)
    this.onChangeTime = this.onChangeTime.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
  }

  componentDidMount () {
    this.getImpersonationAccess()
  }

  getImpersonationAccess () {
    this.props.getImpersonationAccess().then((res) => {
      this.setState({
        ImpersonateAccessInfo: res.data
      })
    }, (err) => {
      console.log(err)
    })
  }

  saveImpersonationAccess (info) {
    this.props.saveImpersonationAccess(info).then((res) => {
      this.setState({
        ImpersonateAccessInfo: res.data
      })
      // window.toastr.success(translation('512'))
    }, (err) => {
      this.updateSelected()
      window.toastr.error(translation(err.response.data.DictionaryKey), translation('293'))
    })
  }

  updateSelected () {
    this.setState({
      ImpersonateAccessInfo: {
        ...this.state.ImpersonateAccessInfo,
        ImpersonationExpiryDate: this.state.previewDateTime
      }
    })
  }

  onChange (e) {
    this.setState({
      ImpersonateAccessInfo: {
        ...this.state.ImpersonateAccessInfo,
        [e.target.name]: e.target.checked
      }
    }, () => {
      this.saveImpersonationAccess(this.state.ImpersonateAccessInfo)
    })
  }

  onChangeDate (date) {
    let { ImpersonationExpiryDate } = this.state.ImpersonateAccessInfo
    let previewDateTime = ImpersonationExpiryDate
    this.setState({
      ImpersonateAccessInfo: {
        ...this.state.ImpersonateAccessInfo,
        ImpersonationExpiryDate: date
      },
      previewDateTime
    }, () => {
      let info = {
        ...this.state.ImpersonateAccessInfo,
        ImpersonationExpiryDate: this.state.ImpersonateAccessInfo.ImpersonationExpiryDate.format()
      }
      this.saveImpersonationAccess(info)
    })
  }

  onChangeTime (e) {
    let { ImpersonationExpiryDate } = this.state.ImpersonateAccessInfo
    let splitted = e.target.value.split(':')
    let dateVal = (ImpersonationExpiryDate !== null) ? window.CustomDate(ImpersonationExpiryDate) : window.CustomDate()
    let hours = splitted[0]
    let minutes = splitted[1]
    let combined = moment(dateVal).hours(parseInt(hours)).minutes(parseInt(minutes))
    let previewDateTime = ImpersonationExpiryDate
    this.setState({
      ImpersonateAccessInfo: {
        ...this.state.ImpersonateAccessInfo,
        ImpersonationExpiryDate: combined
      },
      previewDateTime
    }, () => {
      let info = {
        ...this.state.ImpersonateAccessInfo,
        ImpersonationExpiryDate: this.state.ImpersonateAccessInfo.ImpersonationExpiryDate.format()
      }
      this.saveImpersonationAccess(info)
    })
  }

  render () {
    let { ImpersonationAccessEnabled, ImpersonationExpiryDate, SupportTeams } = this.state.ImpersonateAccessInfo
    let times = this.state.SupportAccessTimes

    // Date
    let date = ''
    if (typeof ImpersonationExpiryDate !== 'undefined' && ImpersonationExpiryDate !== null && ImpersonationExpiryDate !== '') {
      date = window.CustomDate(ImpersonationExpiryDate)
    }

    const ToNearest30Minutes = (datetime) => {
      let remainder = datetime.minute() % 30
      if (remainder < 15) {
        remainder = 0 - remainder
      } else {
        remainder = 30 - remainder
      }
      return moment(datetime).add(remainder, 'minutes').format('HH:mm')
    }

    // Time string
    let timeString = ''
    if (date !== '') {
      timeString = ToNearest30Minutes(moment(ImpersonationExpiryDate))
    }

    const hide = () => {
      let className
      if (!ImpersonationAccessEnabled) {
        className = 'hide'
      } else {
        className = 'show'
      }
      return className
    }

    const renderSupportTeam = (val, key) => {
      return (
        <Label size='m' key={key}>{val.ChainName}</Label>
      )
    }

    return (
      <div className='supportAccess__screen'>
        <Col span='2'>
          <Panel title={translation('17967')}>
            <Switch labelText={translation('17970')} helpText={translation('17972')} name='ImpersonationAccessEnabled' checked={ImpersonationAccessEnabled} onChange={this.onChange} />
            <Label size='m'>{translation('18038')}</Label>
            <br />
            {SupportTeams.map(renderSupportTeam)}
            <br />
            <LabelWrapper className={hide()} labelText={translation('17971')} helpText={translation('17973')}>
              <Grid cols={[3, 1]}>
                <DateTime
                  inputProps={{ name: 'ImpersonationExpiryDate', disabled: !ImpersonationAccessEnabled }}
                  closeOnSelect
                  dateFormat='DD-MM-YYYY'
                  timeFormat={false}
                  value={date}
                  onChange={this.onChangeDate}
                  helpText={translation('17973')} />

                <DropDown name='SupportAccessTimes' value={timeString} onChange={this.onChangeTime} disabled={!ImpersonationAccessEnabled} >
                  {times.map((val, index) => {
                    return (<option key={index} value={val}>{val}</option>)
                  })}
                </DropDown>
              </Grid>
            </LabelWrapper>
          </Panel>
        </Col>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getImpersonationAccess,
  saveImpersonationAccess
})(SupportAccessUser)



// WEBPACK FOOTER //
// ./src/app/pages/SupportAccessUser/index.js